import API from '@aws-amplify/api';
import _, { cloneDeep } from 'lodash';
import $ from 'jquery';
import localStorageUtil from '@/common/utils/localStorageUtil';
import DetailEmailTicket from '@/component/ticketList/emailTicket/DetailEmailTicket';
import TicketList from '@/component/ticketList/TicketList';
import ChatThread from '@/component/chatThread/ChatThread';
import DetailTicket from '@/component/chatThread/DetailTicket';
import AddTicket from '@/component/common/layout/addTicket/AddTicket';
import Utils from '@/common/utils/utils';
import FormManagement from '@/component/formManagement/FormManagement';
import UserManagement from '@/component/system/UserManagement';
import ListTicketKnowledge from '@/component/ticketKnowledge/ListTicketKnowledge';
import NotificationList from '@/component/notification/NotificationList';
import UserProfile from '@/component/userProfile/UserProfile';
import OrganizationProfile from '@/component/system/OrganizationProfile';
import ProjectManagement from '@/component/system/ProjectManagement';
import ProjectUserManagement from '@/component/project/ProjectUserManagement';
import DrilldownAndDetailSearch from '@/component/ticketKnowledge/DrilldownAndDetailSearch';
import DetailTicketKnowledge from '@/component/ticketKnowledge/DetailTicketKnowledge';
import DetailTicketPDFKnowledge from '@/component/ticketKnowledge/DetailTicketPDFKnowledge';
import ChatThreadKnowledge from '@/component/chatThread/chatKnowledge/ChatThreadKnowledge';
import Constant from '@/common/constant/Constant';
import ProjectSettingIframe from '@/component/system/ProjectSettingIframe';
import { getRecoil, getRecoilPromise, setRecoil } from "recoil-nexus";
import { isManagerByProjectInuseSelector } from '@/state/selector/projectSelector';
import DetailTicketDraft from '@/component/ticketList/DetailTicketDraft';
import { userAtom } from '@/state/atom/userAtom';
import  ListOrganization  from '@/component/rootOrganization/ListOrganization';
import { getListActiveB2BCustomerSelector, getListActiveB2BHelpdeskSelector } from '@/state/selector/ticketSelector';
import ProjectCustomerManagement from '@/component/project/ProjectCustomerManagement';
import CorporationCustomerManagement from '@/component/project/CorporationCustomerManagement';
import PublicKnowledgeSiteSetting from '@/component/project/PublicKnowledgeSiteSetting';
import SettingChatbot from '@/component/project/SettingChatbot';
import PreviewChatBot from '@/component/publicPages/previewChatBot/PreviewChatBot';
import KnowledgeUploadCsv from '@/component/ticketKnowledge/KnowledgeUploadCsv';
import ProductManagement from '@/component/productManagement/ProductManagement';
import CorporationContractDetail from '@/component/rootOrganization/CorporationContractDetail';
import NormalViewContractDetail from '@/component/project/NormalViewContract/NormalViewContractDetail';
import SettingAI from '@/component/project/SettingAI';
import MCPServerSetting from '@/component/project/MCPServerSetting';
import PanelManagement from '@/component/project/PanelManagement/PanelManagement';
import ChatAI from '@/component/chatAI/ChatAI';
import { checkPermissionOpenTabChatAIOnServer } from '@/component/chatAI/handler/ChatAIHandler';
import ProjectProfileManagement from '@/component/project/ProjectProfileManagement';
import { getPublicAPI } from '@/service/publicService';
import { getUserById, updateUserById } from '@/service/userService';
import { getTicketById } from '@/service/ticketService';
import { currentProjectIsCustomerOfProjectTarget, currentProjectIsHelpdeskOfProjectTarget, getProjectIdListUserIsB2C } from '@/service/projectService';
import { getCorporationById } from '@/service/organizationService';
import { getListChatThread } from '@/service/chatAIService';
import { getProjectById } from '@/service/projectService';
import PanelUtils from '@/common/utils/PanelUtils';
import { handleUserNotHavePermission, userAccessShareLinkTicket } from '../../chatThread/handler/MessageHandler';
import { v4 as uuidv4} from 'uuid';
import BusinessAppDetail from '@/component/project/BusinessAppDetail/BusinessAppDetail';
import { filterPanelTabByManagementPanel } from '@/component/project/handler/PanelManagementHandler';
import { projectInuseDetailAtom } from '@/state/atom/projectAtom';

let panelListBackup = [];

function hiddenPanelNotDisplay(currentIndex, panelList) {
    for (let i = 0; i < panelList.length; i++) {
        if(i < currentIndex || i > currentIndex + 2){
            $(`#tns1-item${i}`).addClass("panel-container-hidden");
        }
    }
}

function showPanelNotDisplay(currentIndex, panelList) {
    for (let i = 0; i < panelList.length; i++) {
        if(i < currentIndex || i > currentIndex + 2){
            $(`#tns1-item${i}`).removeClass("panel-container-hidden");
        }
    }
}

export const onBeforeDragStartHandler = (event, argsAll, settingSlide, panelList, currentIndex) => {
    hiddenPanelNotDisplay(currentIndex, panelList);

    //disable slide before drag start
    let newSetting = _.cloneDeep(settingSlide);
    newSetting.disable = true;
    argsAll.setSettingSlide(newSetting);
    argsAll.setSettingSlideRecoilState(newSetting);

    //set current panelList into panelListBackup, use to reorder panelList after DragEnd
    panelListBackup = _.cloneDeep(panelList);
};

export const handleOnDragEnd = (result, argsAll, panelList, settingSlide, currentIndex) => {
    let newSetting;
    if (!result.destination) {
        
        argsAll.setPanelList(panelListBackup);
        
        argsAll.setPanelListRecoilState(panelListBackup);

        newSetting = _.cloneDeep(settingSlide);
        newSetting.disable = false;
        newSetting.startIndex = currentIndex;

        argsAll.setSettingSlide(newSetting);
        argsAll.setSettingSlideRecoilState(newSetting);
        return;
    }

    //reorder panelList after DragEnd
    const items = Array.from(panelListBackup);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    
    argsAll.setPanelList(items);
    
    argsAll.setPanelListRecoilState(items);

    //enable slide and set current start index
    newSetting = _.cloneDeep(settingSlide);
    newSetting.disable = false;
    newSetting.startIndex = currentIndex;
    argsAll.setSettingSlide(newSetting);
    argsAll.setSettingSlideRecoilState(newSetting);

    showPanelNotDisplay(currentIndex, panelList);
};

export const updateUserWorkspacePanel = async (newState) => {
    try {
        let panelState = _.cloneDeep(newState);
        const selectedProjectId = localStorageUtil.getSelectedProjectId();

        let userDetail = await getUserById(API, localStorageUtil.getUserDetailId());
        if (typeof userDetail === "undefined" || selectedProjectId === null) {
            return;
        }

        const currentProjectInuse = getRecoil(projectInuseDetailAtom);
        if (!currentProjectInuse) {
            return;
        }
        if (currentProjectInuse?.id !== selectedProjectId) {
            return;
        }

        let userWorkspace = Utils.convertJSONDataToObject(userDetail?.workSpace) || {};

        let newWorkspace = [];
        let oldWorkspace = userWorkspace[selectedProjectId] || [];
        let hasConflictAfterSwitchProjectPanelIds = [];

        // cover. Only set newWorkspace when panelState is array and length greater than 0
        if (!Utils.isEmptyArray(panelState)) {
            panelState.forEach(panel => {
                if (panel.projectInuseId && panel.projectInuseId !== selectedProjectId) {
                    hasConflictAfterSwitchProjectPanelIds.push(panel.id);
                } else {
                    panel.tabList?.forEach((tab, index) => {
                        tab.componentName = tab.component?.props.componentName;
                        tab.ticketListType = tab.component?.props.ticketListType;
                        tab.panelId = tab.component?.props.panelId;
        
                        //addTicket
                        tab.createTicketType = tab.component?.props.createTicketType;
        
                        //chatThread
                        tab.ticketId = tab.component?.props.ticketId;
                        tab.isShowAllChatPost = tab.component?.props.isShowAllChatPost;
        
                        //ticket knowledge
                        tab.projectSelectedId = tab.component?.props.projectSelectedId;
                        tab.corporationSelectedId = tab.component?.props.corporationSelectedId;
                        tab.isCustomer = tab.component?.props.isCustomer;
                        tab.customerId = tab.component?.props.customerId;
                        tab.projectId = tab.component?.props.projectId;
                        tab.isDraft = tab.component?.props.isDraft;
                        tab.isEmailTicket = tab.component?.props.isEmailTicket;
                        
                        // cần refactor lại data trước khi update userWorkspace
                        tab.knowledgeInfoChatAi = tab.component?.props.knowledgeInfoChatAi;
                        tab.filterKnowledgeListData = tab.component?.props.filterKnowledgeListData;
                        tab.selectedTicketType = tab.component?.props?.selectedTicketType;
                        tab.tabNameChatAI = tab.component?.props.tabNameChatAI;
                        tab.isDuplicate = tab.component?.props.isDuplicate;
        
                        delete tab.component;
                    });
                }

                newWorkspace.push(panel);
            });
        }

        // Remove panels with conflicting projectInuseId from newWorkspace
        if (hasConflictAfterSwitchProjectPanelIds.length > 0) {
            // console.log('---------- hasConflictAfterSwitchProjectPanelIds ')
            newWorkspace = newWorkspace.filter(
                panel => !hasConflictAfterSwitchProjectPanelIds.includes(panel.id)
            );
        }
        
        const isWorkspaceChanged = !_.isEqual(oldWorkspace, newWorkspace);
        if (isWorkspaceChanged && newWorkspace.length > 0) {
            // console.log('222 ---------- isWorkspaceChanged ', newWorkspace);
            
            userWorkspace[selectedProjectId] = newWorkspace;
            // console.log('222 ---------- userWorkspace ', userWorkspace);

            userDetail.workSpace = JSON.stringify(userWorkspace);
            let userDetailForUpdate = {
                id: userDetail.id,
                workSpace: userDetail.workSpace
            }

            await updateUserById(API, userDetailForUpdate);

            let userDetailState = cloneDeep(getRecoil(userAtom));

            userDetailState.workspace = userWorkspace;

            setRecoil(userAtom, userDetailState);
        }
    } catch (error) {
        console.log('updateUserWorkspacePanel error : ', error)
    }
};

export const initWorkspacePanel = async (props, userWorkspace, projectInuse) => {
    let projectInuseId = projectInuse?.id || localStorageUtil.getSelectedProjectId();

    if (!projectInuse || Utils.isEmptyObject(projectInuse)) {
        projectInuse = await getProjectById(API, projectInuseId)
    }

    let userDetail = props?.userDetail;
    if (!userDetail) {
        
        userDetail = await getUserById(API, localStorageUtil.getUserDetailId());
        
        userWorkspace = userDetail.workSpace;
    }
    props.userDetail = userDetail;

    let firstRenderPanelList = [];
    if (Utils.isEmpty(userWorkspace) || Utils.isEmptyString(userWorkspace)) {
        let userDefaultWorkspace = await getUserById(API, localStorageUtil.getUserDetailId());
        userWorkspace = userDefaultWorkspace?.workSpace;
    }
    try {
        userWorkspace = Utils.convertJSONDataToObject(userWorkspace);
    } catch (error) {
        console.log('initWorkspacePanel err : ', error)
        return firstRenderPanelList;
    }

    if (userWorkspace !== null && userWorkspace[projectInuseId]) {
        
        let workspace = userWorkspace[projectInuseId];
        let ticketListId = [];
        let ticketAppListId = [];
        let shareLinkTicketId = '';
        let openShareLinkPanelType = '';
        let selectThreadId = '';
        let targetTicketIdOfChatPost = '';
        let infoShareLinkTicket = localStorageUtil.getInfoShareLinkTicket();
        if (!Utils.isEmptyObject(infoShareLinkTicket)) {
            let {
                ticketId,
                isHasPermission,
                openPanelType,
                targetThreadId,
                targetTicketIdOfChatPost:ticketIdOfChatPost
            } = infoShareLinkTicket;
            shareLinkTicketId = ticketId;
            openShareLinkPanelType = openPanelType;
            selectThreadId = targetThreadId
            targetTicketIdOfChatPost = ticketIdOfChatPost
            // check view permission. show pop up error in here
            if (
                !isHasPermission ||
                (infoShareLinkTicket.hasOwnProperty('hasChatPermission') &&
                    !infoShareLinkTicket?.hasChatPermission)
            ) {
                return handleUserNotHavePermission(infoShareLinkTicket, props);
            }
        }

        const componentProps = cloneDeep(props);
        delete componentProps.corpSubscription
        delete componentProps.corporationDetail
        delete componentProps.projectDetail
        delete componentProps.userDetail
        delete componentProps.panelListRecoilState
        delete componentProps.panelList
        delete componentProps.projectList
        delete componentProps.notificationAllListState
        delete componentProps.notificationUnReadListState
        delete componentProps.projectDeletedSubscription

        const openChatAiPanel = workspace.find(panel => panel.type === Constant.PANEL_TYPE.OPEN_CHAT_AI);
        if (openChatAiPanel) {
            const corporationInuseId = props.corporationDetail.id || localStorageUtil.getAffiliationOrganization();
            const { payload } = await checkPermissionOpenTabChatAIOnServer(
                API,
                corporationInuseId,
                projectInuseId,
                userWorkspace
            );
            
            const inuseWorkspace = payload?.inuseWorkspace;
            if (!Utils.isEmptyArray(inuseWorkspace)) {
                workspace = workspace.map(panel => {
                    if (panel.type === Constant.PANEL_TYPE.OPEN_CHAT_AI) {
                        const findPanel = inuseWorkspace.find(p => p.id === panel.id);
                        if (!findPanel) return null;
                        if (Utils.isEmptyArray(findPanel?.tabList)) return null;

                        return {
                            ...panel,
                            activeTab: findPanel?.activeTab || 0,
                            tabList: [...findPanel?.tabList]
                        }
                    }

                    return panel
                });

                workspace = workspace.filter(panel => panel);
            }
        }

        for (const panelIndex in workspace) {
            let panel = cloneDeep(workspace[panelIndex]);
            panel.projectInuseId = projectInuseId;
            panel.tabList.forEach(tab => {
                switch (tab.componentName) {
                    case Constant.COMPONENT_NAME.TICKET_LIST:
                        tab.component = <TicketList 
                            {...componentProps} 
                            componentName={tab.componentName}
                            panelId={tab.panelId} 
                            panelType={panel.type}
                            ticketListType={tab.ticketListType} 
                            // ticketListTab={tab.ticketListTab} 
                        />;
                        break;
                    case Constant.COMPONENT_NAME.ADD_TICKET:
                        tab.component = <AddTicket 
                            {...componentProps} 
                            componentName={tab.componentName}
                            panelId={tab.panelId} 
                            panelType={panel.type} 
                            tabId={tab.id} 
                            createTicketType={tab.createTicketType} 
                            ticketListType={tab.ticketListType}
                            selectedTicketType={tab?.selectedTicketType}
                            // ticketListTab={tab.ticketListTab}
                            ticketId={tab.ticketId}
                        />;
                        break;
                    case Constant.COMPONENT_NAME.CHAT_THREAD: {
                            const threadChatPropsClone = {
                                ...componentProps,
                                selectThreadId:selectThreadId
                            }
                            tab.component = <ChatThread {...threadChatPropsClone} componentName={tab.componentName} panelId={panel.id} ticketId={tab.ticketId} panelType={panel.type}
                            isShowAllChatPost={tab.isShowAllChatPost}  tabId={tab.id}/>
                            if(!ticketListId.includes(tab.ticketId)) {
                                ticketListId.push(tab.ticketId);
                            }
                        }
                        break;
                    case Constant.COMPONENT_NAME.CHAT_THREAD_KNOWLEADGE:
                        tab.component = <ChatThreadKnowledge {...componentProps} componentName={tab.componentName} panelId={panel.id} ticketId={tab.ticketId} panelType={panel.type} tabId={tab.id} />
                        if(!ticketListId.includes(tab.ticketId)) {
                            ticketListId.push(tab.ticketId);
                        }
                        break;
                    case Constant.COMPONENT_NAME.DETAIL_TICKET:
                        tab.component = <DetailTicket {...componentProps} componentName={tab.componentName} panelId={panel.id} ticketId={tab.ticketId} panelType={panel.type} tabId={tab.id}/>
                        if(!ticketListId.includes(tab.ticketId)) {
                            ticketListId.push(tab.ticketId);
                        }
                        break;
                    case Constant.COMPONENT_NAME.DETAIL_TICKET_EMAIL:
                        tab.component = <DetailEmailTicket {...componentProps} componentName={tab.componentName} panelId={panel.id} ticketId={tab.ticketId} panelType={panel.type} tabId={tab.id}/>
                        if(!ticketListId.includes(tab.ticketId)) {
                            ticketListId.push(tab.ticketId);
                        }
                        break;
                    case Constant.COMPONENT_NAME.FORM_MANAGEMENT:
                        tab.component = <FormManagement {...componentProps} componentName={tab.componentName} panelId={tab.panelId} tabId={tab.id}/>
                        break;
                    case Constant.COMPONENT_NAME.USER_MANAGEMENT:
                        tab.component = <UserManagement {...componentProps} componentName={tab.componentName} panelId={tab.panelId} tabId={tab.id}/>
                        break;
                    case Constant.COMPONENT_NAME.USER_PROFILE:
                        tab.component = <UserProfile {...componentProps} componentName={tab.componentName} panelId={tab.panelId} tabId={tab.id}/>
                        break;
                    case Constant.COMPONENT_NAME.ORGANIZATION_PROFILE:
                        tab.component = <OrganizationProfile {...componentProps} componentName={tab.componentName} panelId={tab.panelId} tabId={tab.id}/>
                        break;
                    case Constant.COMPONENT_NAME.PROJECT_MANAGEMENT:
                        tab.component = <ProjectManagement {...componentProps} componentName={tab.componentName} panelId={tab.panelId} tabId={tab.id}/>
                        break;
                    case Constant.COMPONENT_NAME.PROJECT_PROFILE_MANAGEMENT:
                        tab.component = <ProjectProfileManagement {...componentProps} componentName={tab.componentName} panelId={tab.panelId} tabId={tab.id}/>
                        break;
                    case Constant.COMPONENT_NAME.PROJECT_USER_MANAGEMENT:
                        tab.component = <ProjectUserManagement {...componentProps} componentName={tab.componentName} panelId={tab.panelId} tabId={tab.id}/>
                        break;
                    case Constant.COMPONENT_NAME.PROJECT_CUSTOMER_MANAGEMENT:
                        tab.component = <ProjectCustomerManagement {...componentProps} componentName={tab.componentName} panelId={tab.panelId} tabId={tab.id}/>
                        break;
                    case Constant.COMPONENT_NAME.CORPORATION_CUSTOMER_MANAGEMENT:
                        tab.component = <CorporationCustomerManagement {...componentProps} componentName={tab.componentName} panelId={tab.panelId} tabId={tab.id}/>
                        break;
                    case Constant.COMPONENT_NAME.NORMAL_VIEW_CONTRACT_DETAIL:
                        tab.component = <NormalViewContractDetail {...componentProps} componentName={tab.componentName} panelId={tab.panelId} tabId={tab.id}/>
                        break;
                    case Constant.COMPONENT_NAME.LIST_TICKET_KNOWLEDGE:
                        tab.component = (
                            <ListTicketKnowledge
                                {...componentProps}
                                componentName={tab.componentName}
                                panelId={panel.id}
                                projectSelectedId={tab.projectSelectedId}
                                corporationSelectedId={tab.corporationSelectedId}
                                isCustomer={tab.isCustomer}
                                customerId={tab.customerId}
                            />
                        );
                        break;
                    case Constant.COMPONENT_NAME.NOTIFICATION_LIST:
                        tab.component = <NotificationList {...componentProps} componentName={tab.componentName} panelId={panel.id} />
                        break;
                    case Constant.COMPONENT_NAME.DRILLDOWN_AND_DETAIL_SEARCH:
                        tab.component = <DrilldownAndDetailSearch 
                            {...componentProps} 
                            componentName={tab.componentName} 
                            panelId={panel.id}
                            corporationId={tab.corporationId}
                            projectId={tab.projectId}
                            userId={tab.userId}
                            parentPanel={tab.parentPanel}
                            isCustomer={tab.isCustomer}
                        />
                        break;
                    case Constant.COMPONENT_NAME.DETAIL_TICKET_KNOWLEDGE:
                        tab.component = <DetailTicketKnowledge 
                            {...componentProps} 
                            componentName={tab.componentName} 
                            panelId={panel.id}
                            ticketId={tab.ticketId} 
                            panelType={panel.type}
                            tabId={tab.id}
                        />
                        ticketListId.push(tab.ticketId);
                        break;
                    case Constant.COMPONENT_NAME.DETAIL_TICKET_PDF_KNOWLEDGE:
                        tab.component = <DetailTicketPDFKnowledge 
                            {...componentProps} 
                            componentName={tab.componentName} 
                            panelId={panel.id}
                            ticketId={tab.ticketId} 
                            panelType={panel.type}
                            tabId={tab.id}
                        />
                        ticketListId.push(tab.ticketId);
                        break;
                    case Constant.COMPONENT_NAME.PROJECT_SETTING_IFRAME:
                        tab.component = <ProjectSettingIframe {...componentProps} componentName={tab.componentName} panelId={tab.panelId} projectId={tab.projectId}/>
                        break;
                    case Constant.COMPONENT_NAME.DETAIL_TICKET_DRAFT:
                        if (tab.isDuplicate) {
                            tab.tabId = `${Constant.TAB_PANEL_TYPE.TAB_DUPLICATE_TICKET}${uuidv4()}`;
                            tab.id = tab.ticketId;
                        }
                        tab.component = <DetailTicketDraft {...componentProps} componentName={tab.componentName} panelId={panel.id} ticketId={tab.ticketId} panelType={panel.type} tabId={tab.tabId} isDraft={tab.isDraft} isDeletedTicket={tab.isDeletedTicket} isDuplicate={tab.isDuplicate} />
                        if(!ticketListId.includes(tab.ticketId) || tab.isDuplicate) {
                            ticketListId.push(tab.ticketId);
                        }
                        break;
                    case Constant.COMPONENT_NAME.ROOT_LIST_ORG:
                        tab.component = <ListOrganization 
                            {...componentProps} 
                            componentName={tab.componentName}
                            panelId={tab.panelId} 
                            panelType={panel.type}
                        />
                        break;
                    case Constant.PANEL_TYPE.PRODUCT_MANAGEMENT:
                        tab.component = <ProductManagement 
                            {...componentProps} 
                            componentName={tab.componentName}
                            panelId={tab.panelId} 
                            panelType={panel.type}
                            tabId={tab.id}
                            />
                            break;
                    case Constant.COMPONENT_NAME.EDIT_ORG_CONTRACT:
                        tab.component = <CorporationContractDetail 
                            {...componentProps} 
                            componentName={tab.componentName}
                            panelId={tab.panelId} 
                            panelType={panel.type}
                            orgId = {tab.orgId}
                            tabId={tab.id}
                        />
                        break
                    case Constant.COMPONENT_NAME.PUBLIC_KNOWLEDGE_SITE_SETTING:
                       tab.component = <PublicKnowledgeSiteSetting {...componentProps} componentName={tab.componentName} panelType={panel.type} panelId={tab.panelId} tabId={tab.id}/>
                       break;
                    case Constant.COMPONENT_NAME.SETTING_CHAT_BOT:
                        tab.component = <SettingChatbot {...componentProps} componentName={tab.componentName} panelId={tab.panelId} projectId={tab.projectId} panelType={panel.type} tabId={tab.id}/>
                        break;
                    case Constant.COMPONENT_NAME.PREVIEW_CHATBOT:
                        tab.component = <PreviewChatBot {...componentProps} componentName={tab.componentName} panelId={tab.panelId} projectId={tab.projectId} panelType={panel.type} tabId={tab.id}/>
                        break;
                    case Constant.COMPONENT_NAME.KNOWLEDGE_UPLOAD_CSV:
                        tab.component = <KnowledgeUploadCsv {...componentProps} componentName={tab.componentName} panelId={tab.panelId}  panelType={panel.type} tabId={tab.id}/>
                        break;
                    case Constant.COMPONENT_NAME.SETTING_AI:
                        tab.component = <SettingAI {...componentProps} componentName={tab.componentName} panelId={tab.panelId} projectId={tab.projectId} panelType={panel.type} tabId={tab.id}/>
                        break;
                    case Constant.COMPONENT_NAME.MCP_SERVER_SETTING:
                        tab.component = <MCPServerSetting {...componentProps} componentName={tab.componentName} panelId={tab.panelId} projectId={tab.projectId} panelType={panel.type} tabId={tab.id}/>
                        break;
                    case Constant.COMPONENT_NAME.PANEL_MANAGEMENT:
                        tab.component = <PanelManagement {...componentProps} componentName={tab.componentName} panelId={tab.panelId} projectId={tab.projectId} panelType={panel.type} tabId={tab.id}/>
                        break;
                    case Constant.COMPONENT_NAME.BUSINESS_APP_DETAIL:
                        ticketAppListId.push(tab.id)
                        tab.component = <BusinessAppDetail
                            {...componentProps}
                            componentName={tab.componentName}
                            panelId={tab.panelId}
                            projectId={tab.projectId}
                            panelType={panel.type}
                            tabId={tab.id}
                            ticketId={tab.id}
                        />
                        break;
                    case Constant.COMPONENT_NAME.OPEN_CHAT_AI:
                        tab.component = (
                            <ChatAI
                                {...componentProps}
                                componentName={tab.componentName}
                                panelId={tab.panelId}
                                projectId={tab.projectId}
                                panelType={panel.type}
                                tabId={tab.id}
                                filterKnowledgeListData={tab.filterKnowledgeListData}
                                tabNameChatAI={tab.tabNameChatAI}
                            />
                        );
                        break;
                    default:
                        break;
                }
            });

            firstRenderPanelList.push(panel);
        }

        try {
            const shareLinkParams = {
                shareLinkTicketId,
                openShareLinkPanelType,
                selectThreadId,
                targetTicketIdOfChatPost
            }

            firstRenderPanelList = await filterPanelList(
                {...props, projectInuseId},
                ticketListId,
                firstRenderPanelList,
                projectInuse,
                shareLinkParams,
                ticketAppListId
            );

        } catch (error) {
            console.log('-------------- ERROR filterPanelList ----------------------', error)
            return firstRenderPanelList;
        }
    }
    
    // mapping panel size
    firstRenderPanelList = mappingPanelSize(firstRenderPanelList, userDetail, projectInuseId);

    return firstRenderPanelList;
};

export const onChangeProjectInuse = async (argsAll, projectSelected) => {
    try {
        if (!projectSelected) return;

        let projectSelectedId = projectSelected.id;
    
        // update projectInuse for user
        let userDetailForUpdate = {
            id: argsAll?.userDetail?.id
                ? argsAll?.userDetail?.id
                : localStorageUtil.getUserDetailId(),
            projectInuse: projectSelectedId
        };
    
        const userDetailRes = await updateUserById(null, userDetailForUpdate);
    
        localStorageUtil.setSelectedProjectType(projectSelected.type);
        localStorageUtil.setSelectedProjectId(projectSelectedId);
        
        argsAll.setProjectDetail(projectSelected);

        argsAll.setUserDetail(userDetailRes);
        
        if(!Utils.isEmptyObject(userDetailRes)) {

            // reset prev panelList before onchange projectInuse
            argsAll.setPanelList([]);


            const firstPanel = await initWorkspacePanel(
                {
                    ...argsAll,
                    userDetail: userDetailRes
                },
                userDetailRes.workSpace,
                projectSelected
            );

            argsAll.setPanelList(firstPanel || []);

            // handle set active panel after open shareLink
            handleActivePanelAfterOpenShareLink(firstPanel, argsAll?.setCurrentIndex)
        }

        // comment for now
        // const userPermissionType = Utils.checkUserPermissionKnowledgeService(argsAll?.corporationDetail, projectSelected);
        // setRecoil(userPermissionToViewKnowledgeAtom, prev => ({
        //     ...prev,
        //     type: userPermissionType,
        //     projectSelectedId: projectSelectedId
        // }));
    } catch (error) {
        console.log('onChangeProjectInuse error :>> ', error);
    }
};

const filterPanelList = async (
    props,
    ticketListId,
    panelListInput,
    projectDetail,
    sharelinkParams = {
        shareLinkTicketId: '',
        openShareLinkPanelType: '',
        selectThreadId: '',
        targetTicketIdOfChatPost: '',
    },
    ticketAppListId = []
) => {
    const {
        shareLinkTicketId = '',
        openShareLinkPanelType = '',
        selectThreadId = '',
        targetTicketIdOfChatPost = '',
    } = sharelinkParams;

    let corporationDetail = props.corporationDetail;
    let userDetail = props.userDetail ? props.userDetail : {};
    let userSettingValue = userDetail?.userSetting;
    let isB2CUser = false;
    let projectCustomerIdList = [];

    let panelList = [];

    const isProjectManager = await getRecoilPromise(isManagerByProjectInuseSelector);
    let isAdmin = (Constant.PRIVILEGE_USER.ADMIN_OWNER === userDetail?.privilege ||
        Constant.PRIVILEGE_USER.ADMIN === userDetail?.privilege);
    let adminMode;

    if(!Utils.isEmptyObject(userSettingValue)) {
        userSettingValue = Utils.convertJSONDataToObject(userSettingValue);
        adminMode = userSettingValue.adminMode;
    } else {
        adminMode = Constant.ADMIN_MODE.OFF;
    }

    // management panel
    const {
        isFilterQA,
        isFilterHelpdesk,
        isFilterKnowledge,
        listActiveAppDetail
    } = await filterPanelTabByManagementPanel(corporationDetail, projectDetail, ticketAppListId)
    let ticketIds = [...ticketListId];    

    if (shareLinkTicketId) {
        const isExistShareLinkTicket = ticketListId.includes(shareLinkTicketId);
        ticketIds = isExistShareLinkTicket 
        ? [...ticketListId] 
        : [...ticketListId, shareLinkTicketId];
    }

    let ticketData = await Promise.all(
        ticketIds.map((ticketId) => {
            return getTicketById(props?.API, ticketId, false, true, true);
        })
    );
    ticketData = ticketData.flat().filter(ticket => !!ticket);

    const shareLinkDetail = ticketData.find(ticket => ticket.id === shareLinkTicketId);
    if (shareLinkDetail) {
        const { newPanelList, openShareLinkIndex } = await handleAddMorePanelTabOpenShareLink(
            props,
            panelListInput,
            shareLinkDetail,
            openShareLinkPanelType,
            selectThreadId,
            targetTicketIdOfChatPost
        );
        panelListInput = newPanelList;
        localStorageUtil.setInfoShareLinkTicket(JSON.stringify({openShareLinkIndex, isHasPermission: true}))
    }
    
    let deletedTicket = ticketData.filter(
        ticket =>
            !Utils.isEmpty(ticket?.deletedAt) ||
            (ticket?.isAiAutoTicket && !ticket?.isEnableAiAuto) ||
            (ticket?.isSDAutoTicket && !ticket?.isEnableSDAuto) ||  
            (ticket?.isAiTelephonePromptTicket && !ticket?.isEnableTelephoneAgent)
    );
    
    if (Utils.isB2CUser(userDetail)) {
        isB2CUser = true;
        projectCustomerIdList = await getProjectIdListUserIsB2C(API, userDetail.id); 
    }
    
    let isOffKnowledgeBot = !corporationDetail?.limitValue?.knowledgeBot;
    for (const panelIndex in panelListInput) {
        let panel = cloneDeep(panelListInput[panelIndex]);

        // ----------------------------------- abort panel ------------------------------
        if ((!projectDetail.isDesk || !isProjectManager || isOffKnowledgeBot) && [Constant.PANEL_TYPE.PREVIEW_CHATBOT].includes(panel.type)) {
            // console.log('namnhdebug continue 1')
            continue;
        }

        // close panel upload csv knowledge
        if ([Constant.PANEL_TYPE.KNOWLEDGE_UPLOAD_CSV].includes(panel.type)) {
            // console.log('namnhdebug continue 2')
            continue;
        }

        // Base project and Guest customer project
        if (
            [Constant.PROJECT_TYPE.BASE, Constant.PROJECT_TYPE.CUSTOMER].includes(
                projectDetail.type
            ) &&
            [
                Constant.PANEL_TYPE.HELPDESK_TICKET_LIST,
                Constant.PANEL_TYPE.HELPDESK_TICKET_DETAIL,
                Constant.PANEL_TYPE.HELPDESK_CHATTHREAD,
            ].includes(panel.type)
        ) {
            // console.log('namnhdebug continue 3')
            continue;
        }

        // desk service off
        if (
            corporationDetail?.deskService === Constant.STATUS_SERVICE_PERMISSION.OFF &&
            [Constant.PANEL_TYPE.PREVIEW_CHATBOT].includes(panel.type)
        ) {
            // console.log('namnhdebug continue 4')
            continue;
        }

        // knowledge service off 
        const knowledgeService = [
            Constant.CORPORATION_CONTRACT_TYPE.GUEST,
            Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK
        ].includes(corporationDetail?.contractType)
            ? Utils.convertJSONDataToObject(corporationDetail?.inviterSetting)?.usingKnowledgeService
            : corporationDetail?.knowledgeService;

        if (knowledgeService === Constant.STATUS_SERVICE_PERMISSION.OFF) {
            if (isB2CUser && (!projectCustomerIdList || Utils.isEmptyArray(projectCustomerIdList))) {
                // b2cOrg can not view knowledge when knowledgeService off
                continue;
            }

            /**
             * PANEL KNOWLEDGE_TICKET_LIST, DRILLDOWN_AND_DETAIL_SEARCH : keep although knowledgeService = off
             */

            if (panel.type === Constant.PANEL_TYPE.KNOWLEDGE_TICKET_DETAIL) {
                const knowledgeTicketTabIds = panel.tabList.map(tab =>
                    tab?.id
                );
                const allBusinessAppList = await getBusinessAppByIds(knowledgeTicketTabIds);
                const allBusinessAppIds = allBusinessAppList.map(app => app.id);
                const existedBusinessAppInTabList = panel?.tabList?.some(tab =>
                    allBusinessAppIds.includes(tab.id)
                );
                if (!existedBusinessAppInTabList) continue;

                //replace, only keep business app in tab list
                let onlyBusinessAppListInTabList = panel.tabList.filter(tab =>
                    allBusinessAppList.map(app => app.id).includes(tab.id)
                );
                if (Utils.isEmptyArray(onlyBusinessAppListInTabList)) continue;
                panel.tabList = onlyBusinessAppListInTabList;
            }

            if (panel.type === Constant.PANEL_TYPE.PREVIEW_CHATBOT) {
                continue;
            }
        }

        if([
            Constant.PANEL_TYPE.KNOWLEDGE_HELPDESK_TICKET_LIST
        ].includes(panel.type)) {
            const corpTargetId = panel.tabList[0]?.corporationSelectedId;
            let corporationTarget = await getCorporationById(props?.API, corpTargetId);
            if(corporationTarget.knowledgeService === Constant.STATUS_SERVICE_PERMISSION.OFF) {
                // console.log('namnhdebug continue 6')
                continue;
            }
        }

        if (
            corporationDetail?.publicService === Constant.STATUS_SERVICE_PERMISSION.OFF &&
            [Constant.PANEL_TYPE.PREVIEW_CHATBOT].includes(panel.type)
        ) {
            continue;
        }

        if (
            (!isAdmin || adminMode === Constant.ADMIN_MODE.OFF || !corporationDetail?.rootFlag) &&
            [
                Constant.PANEL_TYPE.PRODUCT_MANAGEMENT,
                Constant.PANEL_TYPE.ROOT_LIST_ORG
            ].includes(panel.type)
        ) {
            continue;
        }

        if (
            (!isAdmin || adminMode === Constant.ADMIN_MODE.OFF) &&
            [Constant.PANEL_TYPE.SYSTEM_MANAGEMENT].includes(panel.type)
        ) {
            continue;
        }

        if (panel.type === Constant.PANEL_TYPE.FORMAT_MANAGEMENT && !isProjectManager) {
            continue;
        } 

        if ([
            Constant.PANEL_TYPE.CUSTOMER_TICKET_LIST
        ].includes(panel.type) && isFilterQA) {
            continue;
        }

        if ([
            Constant.PANEL_TYPE.HELPDESK_TICKET_LIST,
            Constant.PANEL_TYPE.HELPDESK_TICKET_LIST_DRILLDOWN_AND_DETAIL_SEARCH
        ].includes(panel.type) && isFilterHelpdesk) {
            continue;
        }

        if ([
            Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST,
            Constant.PANEL_TYPE.KNOWLEDGE_PRJ_INUSE_DRILLDOWN_AND_DETAIL_SEARCH
        ].includes(panel.type) && isFilterKnowledge) {
            continue;
        }

        if (panel.type === Constant.PANEL_TYPE.BUSINESS_APP_DETAIL) {
            if (Utils.isEmptyArray(listActiveAppDetail)) {
                continue;
            }

            // logic remove tab from  panel
            let tabList = cloneDeep(panel.tabList);
            const listActiveAppId = listActiveAppDetail.map(app => app?.id);
            const clonedActiveTabList = tabList.filter(tab => [...listActiveAppId].includes(tab.tabId));
            
            // re-define tabName ( ticketOutline )
            clonedActiveTabList.forEach(tab => {
                const appDetail = listActiveAppDetail.find(app => app?.id === tab.tabId);
                if (appDetail) {
                    tab.ticketOutline = appDetail?.name;
                }
            });

            panel.tabList = clonedActiveTabList;
            panel.activeTab = 0;

            panelList.push(panel);
            continue;
        }

        // ----------------------------------- logic remove tab from  panel ------------------------------
        if ([Constant.PANEL_TYPE.OPEN_CHAT_AI].includes(panel.type)) {
            // Remove panel if B2C user is not B2C of any project
            let tabList = cloneDeep(panel.tabList);
            if (isB2CUser) {
                if (!projectCustomerIdList || Utils.isEmptyArray(projectCustomerIdList)) continue;
                if (Utils.isEmptyArray(tabList)) {
                    continue;
                }

                tabList = tabList.filter(tab => projectCustomerIdList.includes(tab?.filterKnowledgeListData?.projectIdKnowledgeSelected))
                if (Utils.isEmptyArray(tabList)) continue;
                panel.tabList = tabList;
                panel.activeTab = 0;
                panelList.push(panel);
                continue;
                
            }
            // Remove tab aiAuto when aiAutoChatThread is deleted
            const listAiAutoTab = tabList.filter(tab => !!tab?.filterKnowledgeListData?.aiAutoLog);
            if (!Utils.isEmptyArray(listAiAutoTab)) {
                let AiAutoTabIds = listAiAutoTab.map(tab => tab.id);
                let listChatThreadDetail = await getListChatThread(AiAutoTabIds);

                let deletedChatThreadIds = AiAutoTabIds.filter(tabId =>
                    !listChatThreadDetail.some(thread => thread.id === tabId)
                )
                if (!Utils.isEmptyArray(deletedChatThreadIds)) {
                    tabList = tabList.filter(tab => !deletedChatThreadIds.includes(tab.id));
                    if (Utils.isEmptyArray(tabList)) {
                        panelList = panelList.filter(p => p.id !== panel.id)
                        continue;
                    }

                    panel.tabList = tabList;
                    panel.activeTab = 0;
                }
            }
        }

        if ([Constant.PANEL_TYPE.PROJECT_MANAGEMENT].includes(panel.type)) {
            let tabList = cloneDeep(panel.tabList);
            let isUpdatedPanel = false;
            if (!isProjectManager) {
                // console.log('namnhdebug if 1')
                tabList = tabList.filter(
                    tab =>
                        ![
                            Constant.TAB_PANEL_TYPE.SYSTEM_PUBLIC_KNOWLEDGE_SITE_SETTING,
                            Constant.TAB_PANEL_TYPE.SYSTEM_PROJECT_SETTING_CHATBOT,
                            Constant.PANEL_TYPE.PREVIEW_CHATBOT,
                            Constant.TAB_PANEL_TYPE.SYSTEM_PROJECT_SETTING_AI,
                            Constant.TAB_PANEL_TYPE.MCP_SERVER_SETTING,
                            Constant.TAB_PANEL_TYPE.PANEL_MANAGEMENT,
                            Constant.TAB_PANEL_TYPE.SYSTEM_PROJECT_PROFILE_MANAGEMENT,
                        ].includes(tab.id)
                );
                isUpdatedPanel = true;
            }
            let corporationSetting = Utils.convertJSONDataToObject(corporationDetail?.corporationSetting);
            if (corporationDetail?.limitValue?.mcpServer !== Constant.STATUS_SERVICE_PERMISSION.ON || corporationSetting?.usingMCPServer !== Constant.STATUS_SERVICE_PERMISSION.ON) {
                tabList = tabList.filter(
                    tab => ![Constant.TAB_PANEL_TYPE.MCP_SERVER_SETTING].includes(tab.id)
                );
            }

            if ((corporationDetail?.publicService === Constant.STATUS_SERVICE_PERMISSION.OFF || !projectDetail.isDesk) && !isUpdatedPanel) {
                // console.log('namnhdebug if 2')
                tabList = tabList.filter(
                    tab =>
                        ![
                            Constant.TAB_PANEL_TYPE.SYSTEM_PUBLIC_KNOWLEDGE_SITE_SETTING,
                            Constant.TAB_PANEL_TYPE.SYSTEM_PROJECT_SETTING_CHATBOT,
                            Constant.PANEL_TYPE.PREVIEW_CHATBOT
                        ].includes(tab.id)
                );
            }

            let isOffSettingAI = false;

            if (corporationDetail?.contractType === Constant.CORPORATION_CONTRACT_TYPE.GUEST) { // if project is support
                isOffSettingAI = true
                isUpdatedPanel = false
            } else if (corporationDetail?.contractType === Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK) { // if project is partner
                isOffSettingAI = corporationDetail.inviterUsingChatAI === Constant.STATUS_SERVICE_PERMISSION.OFF
            } else {
                // console.log('namnhdebug if 4')
                isOffSettingAI = corporationDetail?.limitValue?.usingChatAI === Constant.STATUS_SERVICE_PERMISSION.OFF;
            }
            
            if (isOffSettingAI && !isUpdatedPanel) {
                // console.log('namnhdebug if 5')
                tabList = tabList.filter(
                    tab => ![Constant.TAB_PANEL_TYPE.SYSTEM_PROJECT_SETTING_AI].includes(tab.id)
                );
            }

            if (isOffKnowledgeBot) {
                tabList = tabList.filter(
                    tab => ![Constant.TAB_PANEL_TYPE.SYSTEM_PROJECT_SETTING_CHATBOT].includes(tab.id)
                );
            }

            panel.tabList = tabList;
            if (Utils.isEmptyArray(panel.tabList)) {
                // console.log('namnhdebug continue 13')
                continue;
            }

            panel.activeTab = 0;
            panelList.push(panel);
            // console.log('namnhdebug continue 14')
            continue;
        }

        if (panel.type === Constant.PANEL_TYPE.SYSTEM_MANAGEMENT) {
            let tabList = cloneDeep(panel.tabList);
            //remove project user panel, form panel, personal panel from old workspace
            tabList = tabList.filter(
                tab =>
                    ![
                        Constant.TAB_PANEL_TYPE.SYSTEM_PROJECT_USER_MANAGEMENT,
                        Constant.TAB_PANEL_TYPE.SYSTEM_FIELD_MANAGEMENT,
                        Constant.TAB_PANEL_TYPE.SYSTEM_USER_PROFILE
                    ].includes(tab.id) &&
                    !tab.id?.startsWith(Constant.PANEL_TYPE.SYSTEM_PROJECT_SETTING_IFRAME)
            );

            if (!isAdmin || (isAdmin && adminMode === Constant.ADMIN_MODE.OFF)) {
                tabList = tabList.filter(tab => {
                    return ![Constant.TAB_PANEL_TYPE.SYSTEM_ORG_PROFILE, 
                        Constant.TAB_PANEL_TYPE.SYSTEM_PROJECT_MANAGEMENT,
                        Constant.TAB_PANEL_TYPE.SYSTEM_USER_MANAGEMENT,
                        Constant.TAB_PANEL_TYPE.SYSTEM_CORPORATION_CUSTOMER_MANAGEMENT,
                        Constant.TAB_PANEL_TYPE.MCP_SERVER_SETTING
                    ].includes(tab.id);
                });
            }

            if (corporationDetail?.limitValue?.mcpServer !== Constant.STATUS_SERVICE_PERMISSION.ON) {
                tabList = tabList.filter(
                    tab => ![Constant.TAB_PANEL_TYPE.MCP_SERVER_SETTING].includes(tab.id)
                );
            }

            // desk service off
            if (
                corporationDetail?.deskService === Constant.STATUS_SERVICE_PERMISSION.OFF
            ) {
                tabList = tabList.filter(tab => {
                    return ![
                        Constant.PANEL_TYPE.SYSTEM_CORPORATION_CUSTOMER_MANAGEMENT
                    ].includes(tab.id);
                });
            }

            panel.tabList = tabList;
            if (Utils.isEmptyArray(panel.tabList)) {
                // console.log('namnhdebug continue 15')
                continue;
            }
            panel.activeTab = 0;
            panelList.push(panel);
            // console.log('namnhdebug continue 16')
            continue;
        }

        // ----------------------------------- logic remove tab from panel for ticket ------------------------------
        if (![Constant.PANEL_TYPE.CUSTOMER_CHATTHREAD,
            Constant.PANEL_TYPE.CUSTOMER_TICKET_DETAIL,
            Constant.PANEL_TYPE.KNOWLEDGE_CHATTHREAD,
            Constant.PANEL_TYPE.KNOWLEDGE_TICKET_DETAIL,
            Constant.PANEL_TYPE.KNOWLEDGE_HELPDESK_TICKET_DETAIL,
            Constant.PANEL_TYPE.HELPDESK_CHATTHREAD,
            Constant.PANEL_TYPE.HELPDESK_TICKET_DETAIL].includes(panel.type)) {
            panelList.push(panel);
            // console.log('namnhdebug continue 17')
            continue;
        }

        let tabList = cloneDeep(panel.tabList);
        let tabListClone = [];
        for (let tab of tabList) {
            if (tab.componentName === "AddTicket") {
                const isTabCreateNew = tab.id.includes('QA_NEW_TICKET_TAB');
                if (isTabCreateNew) {
                    const parentTicketIdMatch = tab.id.match(/req_[a-z0-9-]+/);
                    const parentTicketId = parentTicketIdMatch ? parentTicketIdMatch[0] : null;
                    
                    if (!parentTicketId || !deletedTicket.find(t => t.id === parentTicketId)) {
                        tabListClone.push(tab);
                    }
                } else {
                    tabListClone.push(tab);
                }
            }

            let ticketInTab = ticketData?.find(ticket => ticket.id === tab.id);
            if(!Utils.isEmptyObject(ticketInTab)){
                //get title of ticket
                const settingTitleOfTicket = ticketInTab?.settingTitle
                let ticketOutline = Utils.getTitle(settingTitleOfTicket)
                tab.ticketOutline = ticketOutline;
                tab.isTicketDeleted = !Utils.isEmptyString(ticketInTab.deletedAt);

                // check active form
                let formId = Utils.convertJSONDataToObject(ticketInTab.formId);

                if (!Utils.isEmptyObject(formId) && formId.active) {
                    // ticket knowledge: check view and chat permission
                    if (
                        [
                            Constant.PANEL_TYPE.KNOWLEDGE_CHATTHREAD,
                            Constant.PANEL_TYPE.KNOWLEDGE_TICKET_DETAIL,
                            Constant.PANEL_TYPE.KNOWLEDGE_HELPDESK_TICKET_DETAIL
                        ].includes(panel.type)
                    ) {
                        // Check View Permission
                        let {
                            hasViewPermission,
                            hasChatPermission
                        } = await checkViewAndChatPermissionForTicketKnowledge(corporationDetail, projectDetail, userDetail, ticketInTab);

                        // Check tab page, file knowledge when off attachment field of main ticket
                        let isOffAttachmentMainForm = [Constant.TICKET_PUBLIC.PRIVATE].includes(ticketInTab.public) && 
                        [Constant.TICKET_TYPE.PDF_FILE_KNOWLEDGE, Constant.TICKET_TYPE.PDF_PAGE_KNOWLEDGE].includes(ticketInTab.ticketType)

                        // Check draft
                        let isDraftedTicket =
                            userDetail?.id !== ticketInTab.creator &&
                            [Constant.TICKET_PUBLIC.PRIVATE, Constant.TICKET_PUBLIC.DRAFT].includes(ticketInTab.public);

                        let isDuplicateTicketDelete = tab.isTicketDeleted && tab.isDuplicate;
                        if(!hasViewPermission || isDraftedTicket || isOffAttachmentMainForm || isDuplicateTicketDelete) {
                            // console.log('namnhdebug continue 18')
                            continue;
                        }

                        if (panel.type === Constant.PANEL_TYPE.KNOWLEDGE_TICKET_DETAIL) {
                            tabListClone.push(tab);
                        }

                        if (panel.type === Constant.PANEL_TYPE.KNOWLEDGE_HELPDESK_TICKET_DETAIL) {
                            const corpTargetId = tab?.corporationSelectedId;
                            let corporationTarget = await getCorporationById(props?.API, corpTargetId);
                            if(corporationTarget.knowledgeService === Constant.STATUS_SERVICE_PERMISSION.ON) {
                                tabListClone.push(tab)
                            }
                        }

                        if (
                            panel.type === Constant.PANEL_TYPE.KNOWLEDGE_CHATTHREAD &&
                            hasChatPermission
                        ) {
                            // Note: ticket knowledge can view chat panel but don't send chat
                            // let isPushTabPanel = true;
                            // deletedTicket.forEach(ticket => {
                            //     if(ticket.id === tab.ticketId && !Utils.isEmpty(ticket?.deletedAt)){
                            //         isPushTabPanel = false;
                            //     }
                            // })
                            // if(isPushTabPanel){
                            //     tabListClone.push(tab);
                            // }
                            
                            tabListClone.push(tab);
                        }
                    } else if (
                        [
                            Constant.PANEL_TYPE.CUSTOMER_TICKET_DETAIL,
                            Constant.PANEL_TYPE.CUSTOMER_CHATTHREAD
                        ].includes(panel.type) // remove deleted customer ticket panel
                    ) {
                        let isPushTabPanel = true;
                        deletedTicket.forEach(ticket => {
                            if (
                                ticket.id === tab.ticketId &&
                                !Utils.isEmpty(ticket?.deletedAt)
                            ) {
                                isPushTabPanel = false;
                            }
                        });
                        if (isPushTabPanel) {
                            tabListClone.push(tab);
                        }
                    } else {
                        tabListClone.push(tab);
                    }
                }
            }
        }

        panel.tabList = tabListClone;
        const tabIndex = tabListClone?.findIndex(t => t?.id === shareLinkDetail?.id);
        panel.activeTab = tabIndex !== -1 ? tabIndex : 0;

        if (Utils.isEmptyArray(panel.tabList)){
            // console.log('namnhdebug continue 19')
            continue;
        }

        panelList.push(panel);
    }

    return panelList;
}

export const openShareLinkOnNewWebBrowser = async (argsAll, projectInuseDetail, setUserPermissionView) => {
    let isOpenShareLinkAfterChangeProject = false;

    let infoShareLink = localStorageUtil.getInfoShareLinkTicket();
    if (Utils.isEmptyObject(infoShareLink)) return { isOpenShareLinkAfterChangeProject }

    let targetProjectId = infoShareLink?.targetProjectId;

    // case: haven't login & access share link
    const isCaseHaveNotLogin = !infoShareLink?.hasOwnProperty('isHasPermission')

    if (isCaseHaveNotLogin) {
        const reCheckPermission = await userAccessShareLinkTicket(
            localStorageUtil.getUserDetailId(),
            infoShareLink?.ticketId,
            projectInuseDetail.id,
            infoShareLink?.subDomain,
            infoShareLink?.projectId,
            infoShareLink?.chatPostId,
        );
        const payload = Utils.convertJSONDataToObject(reCheckPermission.payload);
        if (
            !payload.isHasPermission ||
            (payload.hasOwnProperty('hasChatPermission') && !payload?.hasChatPermission)
        ) {
            handleUserNotHavePermission(payload, argsAll);
        } else {
            targetProjectId = payload?.targetProjectId;
            localStorageUtil.setInfoShareLinkTicket(
                JSON.stringify({
                    ...payload,
                    targetTicketIdOfChatPost: payload?.chatPostDetail?.ticketId || "",
                    ticketId: payload?.ticketId || infoShareLink?.ticketId,
                    targetThreadId: payload?.targetThreadId || infoShareLink?.targetThreadId || payload?.selectedThreadDetail?.id,
                    targetChatPostId: payload?.targetChatPostId || infoShareLink?.targetChatPostId || payload?.chatPostDetail?.id
                })
            );
        }
    }

    // handle onchange projectInuse if projectInuseId !== targetProjectId
    const isMustChangeProjectInuse = !Utils.isEmptyString(targetProjectId) && projectInuseDetail.id !== targetProjectId;
    if (isMustChangeProjectInuse) {

        isOpenShareLinkAfterChangeProject = true;

        try {
            const targetProjectDetail = await getProjectById(null, targetProjectId);
            await onChangeProjectInuse(argsAll, targetProjectDetail);

            if (
                projectInuseDetail?.type === Constant.PROJECT_TYPE.BASE &&
                setUserPermissionView &&
                !Utils.isEmptyObject(argsAll?.corporationDetail) &&
                !Utils.isEmptyObject(argsAll?.corporationDetail) &&
                !Utils.isEmptyObject(argsAll?.userDetail)
            ) {
                const userPermissionType = Utils.checkUserPermissionKnowledgeService(
                    argsAll?.corporationDetail,
                    targetProjectDetail
                );
                const knowledgeService = [
                    Constant.CORPORATION_CONTRACT_TYPE.GUEST,
                    Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK
                ].includes(argsAll?.corporationDetail.contractType)
                    ? Utils.convertJSONDataToObject(argsAll?.corporationDetail?.inviterSetting)
                          ?.usingKnowledgeService
                    : argsAll?.corporationDetail.knowledgeService;

                setUserPermissionView({
                    type: userPermissionType,
                    knowledgeService: knowledgeService,
                    projectSelectedId: targetProjectDetail.id,
                    corporationSelectedId: argsAll?.corporationDetail.id,
                    userId: argsAll?.userDetail?.id
                });
            }
        } catch (error) {
            console.log('openShareLink onChangeProjectInuse error: ', error)
        }

    }

    return { isOpenShareLinkAfterChangeProject }
}

export const handleActivePanelAfterOpenShareLink = (panelList, setCurrentIndex = () => {}) => {
    let reGetShareLinkInfo = localStorageUtil.getInfoShareLinkTicket();
    if (
        !Utils.isEmptyObject(reGetShareLinkInfo) &&
        reGetShareLinkInfo?.isHasPermission &&
        reGetShareLinkInfo?.openShareLinkIndex
    ) {
        const openShareLinkPanel = panelList[reGetShareLinkInfo.openShareLinkIndex];

        const activeIndex = PanelUtils.calculateIndexOpenExistPanel(openShareLinkPanel, null, panelList, false, null);

        setCurrentIndex(activeIndex)

        localStorageUtil.deleteInfoShareLinkTicket();
    } else {
        // set init panelIndex when initWorkspace or onchange project
        setCurrentIndex(0);
    }
}

const handleAddMorePanelTabOpenShareLink = async (props, panelListInput, shareLinkTicket, openShareLinkPanelType, selectThreadId, targetTicketIdOfChatPost) => {
    let clonedPanelList = cloneDeep(panelListInput);

    let isCustomer = shareLinkTicket?.affiliationProject !== props?.projectInuseId
    if (openShareLinkPanelType) {
        isCustomer = openShareLinkPanelType !== Constant.TYPE_GET_TICKET_LIST.HELPDESK
    }

    props = {
        ...props,
        ticketListType: isCustomer
            ? Constant.TYPE_GET_TICKET_LIST.CUSTOMER
            : Constant.TYPE_GET_TICKET_LIST.HELPDESK
    }

    let panelType, Component, componentName;

    const ticketType = shareLinkTicket.ticketType;
    switch (ticketType) {
        case Constant.TICKET_TYPE.INVITATION_GUEST_PROJECT:
        case Constant.TICKET_TYPE.INVITATION_GUEST_DESK_PROJECT:
        case Constant.TICKET_TYPE.QA:
        case Constant.TICKET_TYPE.INTERNAL_QA:
        case Constant.TICKET_TYPE.EXTERNAL_QA:
        case Constant.TICKET_TYPE.ESCALATION:
        case Constant.TICKET_TYPE.DELEGATE:
        case Constant.TICKET_TYPE.REQUEST_EXTERNAL_DESK:
        case Constant.TICKET_TYPE.REQUEST_EXTERNAL_CUSTOMER:
        case Constant.TICKET_TYPE.BROADCAST_CHILD:
        case Constant.TICKET_TYPE.BROADCAST_PARENT:
        case Constant.TICKET_TYPE.NOTICE:
            panelType = isCustomer
                ? Constant.PANEL_TYPE.CUSTOMER_TICKET_DETAIL
                : Constant.PANEL_TYPE.HELPDESK_TICKET_DETAIL;
            Component = DetailTicket;
            componentName = Constant.COMPONENT_NAME.DETAIL_TICKET;
            break;

        case Constant.TICKET_TYPE.TASK:
            panelType = Constant.PANEL_TYPE.HELPDESK_TICKET_DETAIL;
            Component = DetailTicket;
            componentName = Constant.COMPONENT_NAME.DETAIL_TICKET;
            break;

        case Constant.TICKET_TYPE.EMAIL:
        case Constant.TICKET_TYPE.EMAIL_REPLY:
            panelType = Constant.PANEL_TYPE.HELPDESK_TICKET_DETAIL;
            Component = DetailEmailTicket;
            componentName = Constant.COMPONENT_NAME.DETAIL_TICKET_EMAIL;
            break;

        case Constant.TICKET_TYPE.KNOWLEDGE:
        case Constant.TICKET_TYPE.MASTER_KNOWLEDGE:
            panelType = Constant.PANEL_TYPE.KNOWLEDGE_TICKET_DETAIL;
            Component = DetailTicketKnowledge;
            componentName = Constant.COMPONENT_NAME.DETAIL_TICKET_KNOWLEDGE;
            break;

        case Constant.TICKET_TYPE.PDF_FILE_KNOWLEDGE:
        case Constant.TICKET_TYPE.PDF_PAGE_KNOWLEDGE:
            panelType = Constant.PANEL_TYPE.KNOWLEDGE_TICKET_DETAIL;
            Component = DetailTicketPDFKnowledge;
            componentName = Constant.COMPONENT_NAME.DETAIL_TICKET_PDF_KNOWLEDGE;
            break;
        case Constant.TICKET_TYPE.TELEPHONE:
            panelType = isCustomer
                ? Constant.PANEL_TYPE.CUSTOMER_TICKET_DETAIL
                : Constant.PANEL_TYPE.HELPDESK_TICKET_DETAIL;
            Component = DetailTicket;
            componentName = Constant.COMPONENT_NAME.DETAIL_TICKET;
            break;
            
        default:
            return clonedPanelList;
    }

    let panelTicketDetail = getOrCreatePanel(clonedPanelList, panelType);
    let shareLinkTicketTab = panelTicketDetail.tabList.find(tab => tab.id === shareLinkTicket.id);
    if (!Utils.isEmptyString(targetTicketIdOfChatPost)) {
        props = {
            ...props,
            targetTicketIdOfChatPost: targetTicketIdOfChatPost
        }
    }
    let component = (
        <Component
            {...props}
            componentName = {componentName}
            panelId = {panelTicketDetail.id}
            ticketId = {shareLinkTicket.id}
            panelType = {panelTicketDetail.type}
            tabId = {shareLinkTicket.id}
            isDeletedTicket = {!!shareLinkTicket.deletedAt}
            isCustomer = {isCustomer}
        />
    );

    if (
        shareLinkTicket.public === Constant.TICKET_PUBLIC.DRAFT &&
        ![
            Constant.TICKET_TYPE.PDF_FILE_KNOWLEDGE,
            Constant.TICKET_TYPE.PDF_PAGE_KNOWLEDGE
        ].includes(ticketType)
    ) {
        component = (
            <DetailTicketDraft
                {...props}
                componentName={Constant.COMPONENT_NAME.DETAIL_TICKET_DRAFT}
                panelId={panelTicketDetail.id}
                ticketId={shareLinkTicket.id}
                panelType={panelTicketDetail.type}
                tabId={shareLinkTicket.id}
                isDraft={true}
                isDeletedTicket={!!shareLinkTicket.deletedAt}
                isDuplicate={false}
            />
        );
        componentName = Constant.COMPONENT_NAME.DETAIL_TICKET_DRAFT;
    }

    if (!shareLinkTicketTab) {
        shareLinkTicketTab = {
            id: shareLinkTicket.id,
            ticketId: shareLinkTicket.id,
            ticketOutline: shareLinkTicket.outline,
            isTicketDeleted: !!shareLinkTicket.deletedAt,
            panelId: panelTicketDetail.id,
            componentName,
            component
        }
        panelTicketDetail.tabList.push(shareLinkTicketTab);
    }

    if (!Utils.isEmptyString(targetTicketIdOfChatPost)) {
        const updatedProps = {
            ...shareLinkTicketTab.component.props,
            targetTicketIdOfChatPost: targetTicketIdOfChatPost,
        };
        shareLinkTicketTab.component = {
            ...shareLinkTicketTab.component,
            props: updatedProps
        }
    }

    panelTicketDetail.activeTab = panelTicketDetail.tabList.findIndex(tab => tab.id === shareLinkTicketTab.id);

    let ticketDetailPanelIndex = clonedPanelList.findIndex(panel => panel.type === panelTicketDetail.type);
    if (!Utils.isEmptyString(targetTicketIdOfChatPost)) {
        panelTicketDetail.tabList = panelTicketDetail?.tabList?.map(tab => {
            const newTab = cloneDeep(tab)
            return {
                ...newTab,

            }
        })
    }

    if (ticketDetailPanelIndex !== -1) {
        clonedPanelList[ticketDetailPanelIndex] = panelTicketDetail;
    } else {
        clonedPanelList.push(panelTicketDetail);
        ticketDetailPanelIndex = clonedPanelList.length - 1;
    }

    // Default openShareLinkIndex is ticketDetailPanelIndex
    let openShareLinkIndex = ticketDetailPanelIndex;
    const TICKET_TYPE_OPEN_WITH_CHAT = [
        Constant.PANEL_TYPE.CUSTOMER_TICKET_DETAIL,
        Constant.PANEL_TYPE.HELPDESK_TICKET_DETAIL
    ];

    let isOpenChatTab = false
    let chatThreadPanelType
    if (panelTicketDetail?.type === Constant.PANEL_TYPE.KNOWLEDGE_TICKET_DETAIL) {
        if (
            !Utils.isEmptyString(selectThreadId) &&
            Utils.getPrefixOfId(selectThreadId) === 'thread'
        ) {
            isOpenChatTab = true;
            chatThreadPanelType = Constant.PANEL_TYPE.KNOWLEDGE_CHATTHREAD;
        }
    } else {
        isOpenChatTab =
            isOpenChat(shareLinkTicket, localStorageUtil.getSelectedProjectId()) && TICKET_TYPE_OPEN_WITH_CHAT.includes(panelTicketDetail.type);
        chatThreadPanelType =
            panelTicketDetail.type === Constant.PANEL_TYPE.CUSTOMER_TICKET_DETAIL
                ? Constant.PANEL_TYPE.CUSTOMER_CHATTHREAD
                : Constant.PANEL_TYPE.HELPDESK_CHATTHREAD;
    }

    if (isOpenChatTab) {
        let panelChat = getOrCreatePanel(clonedPanelList, chatThreadPanelType);
        let tabChatIndex = panelChat.tabList.findIndex(tab => tab.id === shareLinkTicketTab.id);

        if (tabChatIndex !== -1) {
            if (!Utils.isEmptyString(selectThreadId)) {
                const updatedProps = {
                    ...panelChat.tabList[tabChatIndex].component.props,
                    selectThreadId: selectThreadId
                };

                if (chatThreadPanelType === Constant.PANEL_TYPE.KNOWLEDGE_CHATTHREAD) {
                    panelChat.tabList[tabChatIndex].component = (
                        <ChatThreadKnowledge {...updatedProps} />
                    );
                } else {
                    panelChat.tabList[tabChatIndex].component = <ChatThread {...updatedProps} />;
                }
            }
        } else {
            const propsClone = {
                ...props,
                API: props?.API,
                tabId: shareLinkTicketTab?.id,
                ticketId: shareLinkTicketTab?.id,
                panelType: panelType,
                ...(!Utils.isEmptyString(selectThreadId) && { selectThreadId: selectThreadId })
            };
            let tabChatComponent

            if (chatThreadPanelType === Constant.PANEL_TYPE.KNOWLEDGE_CHATTHREAD) {
                tabChatComponent = (
                    <ChatThreadKnowledge
                        {...propsClone}
                        componentName={Constant.COMPONENT_NAME.CHAT_THREAD}
                        panelId={panelChat.id}
                        ticketId={shareLinkTicket.id}
                        panelType={panelChat.type}
                        isShowAllChatPost={false}
                        tabId={shareLinkTicketTab.id}
                    />
                );
            } else {
                tabChatComponent = (
                    <ChatThread
                        {...propsClone}
                        componentName={Constant.COMPONENT_NAME.CHAT_THREAD}
                        panelId={panelChat.id}
                        ticketId={shareLinkTicket.id}
                        panelType={panelChat.type}
                        isShowAllChatPost={false}
                        tabId={shareLinkTicketTab.id}
                    />
                );
            }
            

            const tabChat = {
                id: shareLinkTicket.id,
                tabId: shareLinkTicket.id,
                ticketId: shareLinkTicket.id,
                ticketOutline: shareLinkTicket.outline,
                isTicketDeleted: !!shareLinkTicket.deletedAt,
                component: tabChatComponent,
                componentName: Constant.COMPONENT_NAME.CHAT_THREAD,
                panelId: panelChat.type,
                panelType: panelChat.type,
                isShowAllChatPost: false,
            };

            panelChat.tabList.push(tabChat);
            tabChatIndex = panelChat.tabList.length - 1;
        }

        panelChat.activeTab = tabChatIndex;
        const chatPanelIndex = clonedPanelList.findIndex(panel => panel.type === panelChat.type);
        if (chatPanelIndex !== -1) {
            clonedPanelList[chatPanelIndex] = panelChat;
            if (!Utils.isEmptyString(selectThreadId)) openShareLinkIndex = chatPanelIndex;
        } else {
            clonedPanelList.push(panelChat);
            if (!Utils.isEmptyString(selectThreadId)) openShareLinkIndex = clonedPanelList.length - 1;
        }
    }
    return {
        newPanelList: clonedPanelList,
        openShareLinkIndex
    };
};

const getOrCreatePanel = (panelList, type) => {
    let panel = panelList.find(p => type === p.type);
    if (!panel) {
        panel = {
            id: `${Date.now().toString()}_${uuidv4()}` ,
            isDisplay: true,
            tabList: [],
            activeTab: 0,
            type: type
        };
    }
    return panel;
};

const isOpenChat = (detailTicket, projectInuseId) => {
    const viewFromProjectOfEscalateTicket = projectInuseId !== detailTicket.projectOrigin &&
        projectInuseId !== detailTicket.affiliationProject &&
        !detailTicket.projectTarget.includes(projectInuseId) &&
        ![
            Constant.TICKET_TYPE.TASK,
            Constant.TICKET_TYPE.BROADCAST_PARENT,
            Constant.TICKET_TYPE.BROADCAST_CHILD,
            Constant.TICKET_TYPE.TELEPHONE,
        ].includes(detailTicket.ticketType)
    
    if (!detailTicket) return false;

    if (
        detailTicket?.public === Constant.TICKET_PUBLIC.PUBLIC &&
        detailTicket?.ticketType === Constant.TICKET_TYPE.TASK
    ) {
        return true;
    }

    if (
        [
            Constant.TICKET_TYPE.REQUEST_EXTERNAL_CUSTOMER,
            Constant.TICKET_TYPE.INVITATION_GUEST_PROJECT,
            Constant.TICKET_TYPE.INVITATION_GUEST_DESK_PROJECT,
            Constant.TICKET_TYPE.REQUEST_EXTERNAL_DESK
        ].includes(detailTicket?.ticketType) ||
        viewFromProjectOfEscalateTicket
    ) {
        return false;
    }

    if (Utils.isAnonymousQATicketFromLiveChat(detailTicket)) {
        return true;
    }

    const isNotAnonymousQA = !Utils.isAnonymousQAWaitingTicket(detailTicket) &&
        !Utils.isAnonymousQARejectTicket(detailTicket) &&
        detailTicket?.public !== Constant.TICKET_PUBLIC.DRAFT

    return isNotAnonymousQA;
}

const checkViewAndChatPermissionForTicketKnowledge = async (
    corporationDetail,
    projectDetail,
    userDetail,
    ticketDetail
) => {
    let hasViewPermission = false;
    let hasChatPermission = false;

    if (
        (ticketDetail?.isAiAutoTicket && !ticketDetail?.isEnableAiAuto) ||
        (ticketDetail?.isSDAutoTicket && !ticketDetail?.isEnableSDAuto) ||
        (ticketDetail?.isAiTelephonePromptTicket && !ticketDetail?.isEnableTelephoneAgent)
    ) {
        return {
            hasViewPermission,
            hasChatPermission
        };
    }

    // Validate for file and page knowledge
    if (
        ticketDetail.affiliationOrganization === corporationDetail.id && 
        [Constant.TICKET_TYPE.PDF_FILE_KNOWLEDGE, Constant.TICKET_TYPE.PDF_PAGE_KNOWLEDGE].includes(ticketDetail.ticketType) &&
        !Utils.isDisplaySplitPdfSwitch(corporationDetail)
    ) {
        return {
            hasViewPermission,
            hasChatPermission
        };
    }

    let viewPermission = ticketDetail.viewPermission;
    let chatPermission = ticketDetail.chatPermission;

    const listB2BCustomer = await getRecoil(getListActiveB2BCustomerSelector);
    const listB2BHelpdesk = await getRecoil(getListActiveB2BHelpdeskSelector);

    let isB2BCustomer = currentProjectIsCustomerOfProjectTarget(
        listB2BHelpdesk,
        ticketDetail.affiliationProject
    );
    let isB2BHelpdesk = currentProjectIsHelpdeskOfProjectTarget(
        listB2BCustomer,
        ticketDetail.affiliationProject
    );

    if (viewPermission.includes(Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.PUBLIC)) {
        hasViewPermission = true;
    }

    if (userDetail?.id === ticketDetail.creator) {
        hasViewPermission = true;
        hasChatPermission = true;
    } else if (projectDetail.id === ticketDetail.affiliationProject) {
        if (
            viewPermission.includes(Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.IN_PROJECT) ||
            viewPermission.includes(Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.IN_ORG)
        ) {
            hasViewPermission = true;
        }

        if (
            chatPermission === Constant.KNOWLEDGE_CHAT_PERMISSION.IN_PROJECT ||
            chatPermission === Constant.KNOWLEDGE_CHAT_PERMISSION.IN_ORG
        ) {
            hasChatPermission = true;
        }
    } else if (corporationDetail?.id === ticketDetail.affiliationOrganization &&
        projectDetail.type !== Constant.PROJECT_TYPE.CUSTOMER 
    ) {
        if (viewPermission.includes(Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.IN_ORG)) {
            hasViewPermission = true;
        }

        if (chatPermission === Constant.KNOWLEDGE_CHAT_PERMISSION.IN_ORG) {
            hasChatPermission = true;
        }
    }

    if (
        isB2BCustomer &&
        viewPermission.includes(Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.B2B_CUSTOMER)
    ) {
        hasViewPermission = true;
    }

    if (
        isB2BHelpdesk &&
        viewPermission.includes(Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.B2B_SUPPORT)
    ) {
        hasViewPermission = true;
    }

    let additionalViewPermission = ticketDetail.additionalViewPermission;
    additionalViewPermission = Utils.convertJSONDataToObject(additionalViewPermission);
    if (!Utils.isEmptyObject(additionalViewPermission)) {
        for (let value of Object.values(additionalViewPermission)) {
            if (value.includes(projectDetail.id)) {
                hasViewPermission = true;
                break;
            }
        }
    }

    if (chatPermission === Constant.KNOWLEDGE_CHAT_PERMISSION.NO || !hasViewPermission) {
        hasChatPermission = false;
    } else if (
        [Constant.KNOWLEDGE_CHAT_PERMISSION.BY_VIEW_PERMISSION, Constant.KNOWLEDGE_CHAT_PERMISSION.PUBLIC].includes(chatPermission) &&
        hasViewPermission
    ) {
        hasChatPermission = true;
    }

    return {
        hasViewPermission,
        hasChatPermission
    };
};


export const mappingPanelSize = (panelList, userDetail, selectedProjectId) => {
    let renderPanelList = [...panelList];
    
    let userSetting = userDetail?.userSetting;
    userSetting = Utils.convertJSONDataToObject(userSetting);
    
    const panelSizeSetting = userSetting?.panelSizeSetting || {}
    
    const listInitPanelSize = panelSizeSetting[selectedProjectId] || [];

    renderPanelList = renderPanelList.map(renderPanel => {
        const defaultPanelSize = [Constant.PANEL_TYPE.SYSTEM_MANAGEMENT, Constant.PANEL_TYPE.PROJECT_MANAGEMENT].includes(renderPanel.type)
            ? Constant.PANEL_SIZE.SIZE_3
            : Constant.PANEL_SIZE.SIZE_1;

        if (Utils.isEmptyArray(listInitPanelSize)) {
            return {
                ...renderPanel,
                size: renderPanel.size || defaultPanelSize
            };
        }

        const panelSize = listInitPanelSize.find(initPanel => initPanel.type === renderPanel.type);
        return {
            ...renderPanel,
            size: panelSize ? panelSize.size : defaultPanelSize
        };
    });

    return renderPanelList;
}

const getBusinessAppByIds = async (ids) => {
    try {
        const getBusinessAppOffSidebar = {
            getApiType: Constant.GET_API_PUBLIC_TYPE.GET_TICKET_BUSINESS_APP_BY_IDS,
            ids,
            source: ['id']
        };
        const result = await getPublicAPI(null, getBusinessAppOffSidebar);
        const businessAppList = Utils.convertJSONDataToObject(result?.payload);
        return businessAppList;
    } catch (error) {
        console.log({ error });
        return [];
    }
};